<template>
  <BonusCard
    :id="bonus.id"
    type="deposit"
    :timer="bonusTimer"
    :level="bonus.level"
    data-t="deposit-bonus-card"
  >
    <template #subtitle>
      <p class="awards-bonuses">
        <template
          v-for="(subBonus, index) in filteredMultiBonuses"
          :key="index"
        >
          <span v-if="isStepBonus">{{ t('bonuses.toAmount') }}</span>
          <span>
            {{ subBonus?.amount }}
          </span>
          <StIcon
            v-if="subBonus?.icon"
            :name="subBonus.icon"
            :size="16"
            class="icon"
          />
          <span v-if="subBonus?.text">
            {{ subBonus?.text }}
          </span>
          <span v-if="index + 1 < filteredMultiBonuses.length"> + </span>
        </template>
      </p>
    </template>

    <BonusCardBorderedContent>
      <BonusCardTerms :list="termsList" />
    </BonusCardBorderedContent>

    <template #actions>
      <StButton
        class="button"
        data-t="make-deposit-sgfk"
        type="primary"
        :to="{
          query: {
            modal: 'payments',
            tab: 'deposit',
          },
        }"
      >
        {{ t('bonuses.makeDeposit') }}
      </StButton>
    </template>
  </BonusCard>
</template>

<script setup lang="ts">
import BonusCardTerms from '../BonusCard/parts/BonusCardTerms.vue'
import BonusCardBorderedContent from '../BonusCard/parts/BonusCardBorderedContent.vue'
import BonusCard from '../BonusCard/BonusCard.vue'
import type { DepositBonus, ExtendedDepositBonus } from '../../types'

const { t } = useI18n()

const { bonus } = defineProps<{
  bonus: DepositBonus | ExtendedDepositBonus
}>()

const {
  filteredMultiBonuses,
  isStepBonus,
  rollingMultiplier,
  isMultiBonus,
  minDepositAmount,
} = useDepositBonus(computed(() => bonus))

const bonusTimer = computed(() => ({
  title: t('bonuses.timerTitle'),
  expiresAt: bonus.expiredAt ?? '',
}))

const isVisibleConditions = computed(
  () => rollingMultiplier.value && !isMultiBonus.value && !isStepBonus.value,
)

const termsList = computed(() =>
  [
    {
      label: t('bonuses.depositMinShort'),
      value: minDepositAmount.value,
      isVisible: true,
    },
    {
      label: t('bonuses.bettingCondition'),
      value: t('bonuses.conditions', {
        multiplier: rollingMultiplier.value,
      }),
      isVisible: isVisibleConditions.value,
    },
  ].filter(({ isVisible }) => isVisible),
)
</script>

<style scoped>
.button {
  flex: 1 1 50%;
  min-width: 0;
}

.awards-bonuses {
  overflow: hidden;
  margin: 0;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.icon {
  min-width: 16px;
  margin: calc(var(--spacing-025) * -1) var(--spacing-025);
}
</style>
